import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';

import { WalkthroughConfig } from '../types';

export interface WalkthroughState {
  isWalkthroughActive: boolean;
  run: boolean;
  stepIndex: number;
  config: WalkthroughConfig | null;
  isWalkthroughActivatedManually: boolean;
}

const initialState: WalkthroughState = {
  isWalkthroughActive: false,
  run: false,
  stepIndex: 0,
  config: null,
  isWalkthroughActivatedManually: false,
};

export const walkthroughSlice = createSlice({
  name: 'walkthrough',
  initialState,
  reducers: {
    startWalkthrough: (state) => {
      state.run = true;
      state.isWalkthroughActive = true;
    },
    showWalkthroughStep: (state, action: PayloadAction<number | undefined>) => {
      state.stepIndex = action.payload ?? 0;
    },
    finishWalkthrough: () => {
      window.scrollTo(0, 0);
      return initialState;
    },
    setWalkthroughConfig: (state, action: PayloadAction<WalkthroughConfig>) => {
      state.config = action.payload;
    },
    setIsWalkthroughActivatedManually: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isWalkthroughActivatedManually = action.payload;
    },
  },
});

export const {
  startWalkthrough,
  showWalkthroughStep,
  finishWalkthrough,
  setWalkthroughConfig,
  setIsWalkthroughActivatedManually,
} = walkthroughSlice.actions;

export const walkthroughReducer = walkthroughSlice.reducer;

export const useIsWalkthroughActive = () =>
  useAppSelector((state) => state.walkthrough.isWalkthroughActive);

export const useWalkthroughConfig = () =>
  useAppSelector((state) => state.walkthrough.config);

export const useIsWalkthroughActivatedManually = () =>
  useAppSelector((state) => state.walkthrough.isWalkthroughActivatedManually);
